import i18n from 'i18n';
import { EMP_INFO_COLUMNS } from 'config/type';
import { getLanguage } from 'utils/cookies';

/**
 *
 * @param prefLangCd 대상자 선호언어
 * @param searchLanguage queryString의 언어
 * @returns {boolean}
 */
export const isGlobalLanguage = (prefLangCd = '', searchLanguage = '') => {
  let isGlobal = false;
  const language = getLanguage(); // 로그인 사용자 언어
  if (searchLanguage === 'en') {
    return true;
  }
  if (language === 'en' || (prefLangCd !== '' && language !== prefLangCd)) {
    isGlobal = true;
  }
  return isGlobal;
};

/**
 *
 * @param key 컬럼명
 * @param data 데이터 오브젝트
 * @param isGlobal
 * @returns {string}
 */
export const getUserValue = (key, data, isGlobal = false) => {
  const column = EMP_INFO_COLUMNS[key];
  let value = '';

  if (isGlobal === false || !column || !column.globalColumn) {
    if (data[key]) {
      value = data[key];
    }
  } else {
    value = data[column.globalColumn] || data[key];
  }
  value = value || '';
  return `${value}`.trim();
};

/**
 *
 * @param str
 * @returns {boolean}
 */
export const isBlank = str => {
  let result = false;
  if (str.trim() === '' || str === 'undefined') {
    result = true;
  }
  return result;
};

/**
 *
 * @param item
 * @param isGlobal
 * @param char
 * @returns {string}
 */
export const getDeptValue = (item, isGlobal = true, char = '/') => {
  const depts = [];
  const jobpoNm = getUserValue('jobpoNm', item, isGlobal);
  const deptNm = getUserValue('deptNm', item, isGlobal);
  const compNm = getUserValue('compNm', item, isGlobal);

  if (isBlank(jobpoNm) === false) {
    depts.push(jobpoNm);
  }

  if (isBlank(deptNm) === false) {
    depts.push(deptNm);
  }
  if (isBlank(compNm) === false) {
    depts.push(compNm);
  }
  return depts.join(char);
};

/**
 *
 * @param item
 * @param isGlobal
 * @returns {`${string} ${*}`}
 */
export const getDisplayName = (item, isGlobal) => {
  return `${getUserValue('fnm', item, isGlobal)} ${getDeptValue(item, isGlobal)}`;
};

/**
 *
 * @param url
 * @param w
 * @param h
 * @returns {Window}
 */
export const popupOpen = (url, w, h) => {
  const parentWindow = window.parent || window;
  let xPos = parentWindow.document.body.clientWidth / 2 - w / 2;
  xPos += parentWindow.screenLeft;
  const yPos = screen.availHeight / 2 - h / 2;
  const win = window.open(
    url,
    url,
    `width=${w},height=${h}, left=${xPos}, top=${yPos}, toolbar=0, resizable=yes, status=0`,
  );
  win.focus();
  return win;
};

/**
 *
 * @param error
 * @returns {string}
 */
export const errorlabel = error => {
  if (!error) return '';
  if (!error.key) {
    return i18n.t(error);
  }
  return i18n.t(error.key, { digit: error.digit });
};

/**
 *
 * @param chagBizCn
 * @returns {{}}
 */
export const getSplitChagBizCn = chagBizCn => {
  const _chagBizCn = {};
  if (!chagBizCn) {
    return _chagBizCn;
  }

  const leftIdx = chagBizCn.indexOf('【');
  const rightIdx = chagBizCn.indexOf('】');
  if (leftIdx === 0 && leftIdx < rightIdx) {
    _chagBizCn.workday = chagBizCn.substring(leftIdx, rightIdx + 1).trim(); // ' ' black space + 1 index
    _chagBizCn.subStringChagBizCn = chagBizCn.substring(rightIdx + 1, chagBizCn.length).trim();
    _chagBizCn.maxLength = 100 - chagBizCn.substring(leftIdx, rightIdx + 1).length;
  }
  return _chagBizCn;
};

/**
 *
 * @param workday
 * @param subStringChagBizCn
 * @returns {string}
 */
export const mergeChagBizCn = (workday, subStringChagBizCn) => {
  const chagBizCn = [];
  if (workday !== undefined && workday !== null && workday.length > 0) {
    chagBizCn.push(workday);
  }
  if (subStringChagBizCn !== undefined && subStringChagBizCn !== null && subStringChagBizCn.length > 0) {
    chagBizCn.push(subStringChagBizCn);
  }
  return chagBizCn.join(' ');
};

/**
 *
 * @param nationCodeList
 * @returns {array}
 */
export const mergeNationCode = nationCodeList => {
  const mergeNationCodeList = [];
  for (let i = 0; i < nationCodeList.length; i++) {
    let isFind = false;
    for (let j = 0; j < mergeNationCodeList.length; j++) {
      if (nationCodeList[i].rsrcCdVal === mergeNationCodeList[j].rsrcCdVal) {
        isFind = true;
        const temp = {
          ...mergeNationCodeList[j],
          rsrcKeyVal: `${mergeNationCodeList[j].rsrcKeyVal}|${nationCodeList[i].rsrcKeyVal}`,
        };
        mergeNationCodeList.splice(j, 1, temp);
        break;
      }
    }
    if (!isFind) {
      mergeNationCodeList.push(nationCodeList[i]);
    }
  }
  return mergeNationCodeList;
};

/**
 *
 * @returns {string}
 */
export const getBrowser = () => {
  const agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf('trident') >= 0) {
    return 'IE';
  }
  if (agent.indexOf('edg') >= 0) {
    return 'EDGE';
  }
  if (agent.indexOf('chrome') >= 0) {
    return 'CHROME';
  }
  if (agent.indexOf('firefox') >= 0) {
    return 'FIREFOX';
  }
  if (agent.indexOf('opr') >= 0) {
    return 'OPERA';
  }
  if (agent.indexOf('safari') >= 0) {
    return 'SAFARI';
  }

  return '';
};

/**
 *
 * @returns {boolean}
 */
export const isW2 = () => {
  if (window.location.hostname.indexOf('w2') > -1) {
    return true;
  }
  return false;
};

/**
 *
 * @param compCd
 * @returns {boolean}
 */
export const isOBSCompany = (compCd = null) => {
  return compCd === 'OBS';
};

export const checkIsGlobalPhoneNumber = phone => {
  const KOREAN_PHONE_NUMBER_REGEX = /\+82/;
  return !KOREAN_PHONE_NUMBER_REGEX.test(phone);
};

export const checkHasCountryCode = phone => {
  const HAS_COUNTRY_CODE_REGEX = /\+\d{1,3}/;
  return HAS_COUNTRY_CODE_REGEX.test(phone);
};

/**
 * USER_ID와 외부메일 도메인이 같은지 확인
 * @returns {boolean}
 */
export const checkHasSameDomain = (userIdDomain, extrEmailDomain) => {
  return userIdDomain?.split('@')[1]?.trim() === extrEmailDomain?.split('@')[1]?.trim();
};

/**
 *
 * @param loginMode
 * @returns {boolean}
 */
export const isNormalLogin = loginMode => {
  return loginMode === 'normal';
};
